import React from 'react'
import { Table } from 'react-bootstrap'

function StockPriceTable({ prices }) {
  return (
    <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
      <Table hover size="sm" className="mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Open</th>
            <th>High</th>
            <th>Low</th>
            <th>Close</th>
            <th>Volume</th>
          </tr>
        </thead>
        <tbody>
          {prices.map((row) => (
            <tr key={row.date}>
              <td>{row.date}</td>
              <td>{row.open}</td>
              <td>{row.high}</td>
              <td>{row.low}</td>
              <td>{row.close}</td>
              <td>{row.volume}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default StockPriceTable
